import React from 'react';

import * as T from './interfaces';
import * as S from './styles';

export const Heading = ({
  children,
  level = 1,
  italic = false,
  bold = false,
  fontSizeTitle = false,
  style,
  id,
}: T.IHeading) => (
  <S.Heading
    id={`heading${level}@${id}`}
    data-testid={`heading${level}@${id}`}
    level={level}
    italic={italic}
    bold={bold}
    fontSizeTitle={fontSizeTitle}
    style={style}
  >
    {children}
  </S.Heading>
);
